import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=273e4ba6&scoped=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=273e4ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e4ba6",
  null
  
)

export default component.exports